/** Caminhos absolutos das telas do cadastro — os nomes são os do mobile. */
export const CADASTRO = {
  /* O cadastro começa pelo e-mail: é ele que decide o caminho (A029). */
  /* A062, fase C: criar conta (aqui, em `email`) → código → concluído → onboarding. `/cadastro` sozinho leva à página de entrar. */
  email: '/cadastro/email',
  codigo: '/cadastro/codigo',
  concluido: '/cadastro/concluido',
  onboarding: '/cadastro/onboarding',
  ffPregnancyWeeks: '/cadastro/ffPregnancyWeeks',
  gestationalAge: '/cadastro/gestationalAge',
  ffGestationalStage: '/cadastro/ffGestationalStage',
  postpartum: '/cadastro/postpartum',
  tryingContraception: '/cadastro/tryingContraception',
  fatherFigureType: '/cadastro/fatherFigureType',
  register: '/cadastro/register',
  registerPassword: '/cadastro/registerPassword',
  createPasswordOTP: '/cadastro/createPasswordOTP',
} as const;

/** Estilos que todas as telas repetem (transcritos dos `StyleSheet` do mobile). */
export const ESTILO = {
  /** `title` das telas de opções: 20/700, neutral-800, centralizado, lh 26. */
  titulo: {
    fontSize: 20,
    fontWeight: 700,
    color: 'var(--eva-p-neutral-800)',
    textAlign: 'center',
    lineHeight: '26px',
    margin: 0,
  },
} as const;
